export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 11.999C3 7.029 7.03 3 12 3s9 4.03 9 8.999c0 .574-.06 1.129-.16 1.661a9.02 9.02 0 01-4.295 6.102h-.001a8.946 8.946 0 01-8.848.131l-1.495.467-3.72 1.16 1.16-3.72.466-1.494A8.915 8.915 0 013 11.999zM12 5a7 7 0 00-7 6.999c0 1.343.384 2.592 1.043 3.658l.24.388-.758 2.43.08-.024 2.349-.733.387.238a6.946 6.946 0 007.19.082 7.02 7.02 0 003.344-4.746A7 7 0 0019 12 7 7 0 0012 5z\" fill=\"#000\" fill-opacity=\".9\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};